import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ElementParse, ElementParse_v2 } from "../../ParseClass/Element.Parse";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { NOTDEFINEDVALUE } from "../../providers/service/global-variables.service";

@Component({
    selector: 'app-box-element',
    templateUrl: './box-element.component.html',
    styleUrls: ['./box-element.component.scss'],
    standalone: false
})
export class BoxElementComponent implements OnInit {


    @Input() element: ElementParse_v2 | undefined
    @Input() disabled = false;
    @Output() clickButton = new EventEmitter()
    @Output() clickParentElement = new EventEmitter<{ parent: ElementParse_v2 }>()
    @Input() icon: { matIcon: boolean, pathName: string } | undefined;


    constructor(iconRegistry: MatIconRegistry,
        domSanitizer: DomSanitizer,) {
        iconRegistry.addSvgIcon(
            'parent',
            domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/button/link-icon.svg'));
    }

    ngOnInit(): void {

    }


    getFotometriaValue(element: ElementParse_v2, label: keyof ElementParse_v2) {
        const value = element[label];
        if (label == "environment" || label == "room" || label == "floor") {
            return value === NOTDEFINEDVALUE.environment ? { traduction: 'other' } : { notTraduction: value }
        } else if (label == "type") {
            return value.name
        } else if (label == "parentElement") {
            return value.name
        } else {
            return value
        }
        // if (!isNotNullOrUndefined(value)) {
        //   const ND = this.translateService.instant('NaN');
        //   return ND;
        // } else if (label == 'tipologiaCorpoIlluminante') {
        //   const traduction = this.translateService.instant('dashboard_sidenav.PuntiLuce.tipologiaCorpoIlluminante.possibleValues.' + value.toString().replace(/ /g, '_'));
        //   return (traduction.includes('dashboard_sidenav.PuntiLuce')) ? value : traduction;
        // } else if (typeof value == "string") {
        //   return value;
        // } else if (typeof value == "number") {
        //   return Math.round(value * 100) / 100
        // } else {
        //   const ND = this.translateService.instant('NaN');
        //   return ND;
        // }
    }

    getUnit(label: string) {
        if (label.includes('potenza')) {
            return 'W'
        } else if (label.includes('efficenza')) {
            return 'lm/W'

        } else if (label.includes('flusso')) {
            return 'lm'
        } else {
            return ''
        }
    }


    clickParent() {
        if (this.element?.parentElement) {
            this.clickParentElement.emit({ parent: this.element?.parentElement })
        }
    }

    joinArray(array: string[] | undefined): string | undefined {
        if (array) {
            return array.join(', ')
        } else {
            return undefined
        }
    }
}
